import type { ProductResponse } from './common/productResponse';
import { useListEntityApi } from '@/common/api/listEntityApi';

export interface ListProductResponse {
  ok: true;
  products: ProductResponse[];
}

export function useListProducts() {

  return useListEntityApi<ListProductResponse>({
    url: 'product',
    translate: (t) => t.products.actions.fetchMany,
    async processOk(response) {
      const json = await response.json() as ProductResponse[];

      json.sort((a, b) => a.name.localeCompare(b.name, undefined, {
        numeric: true
      }));

      return {
        ok: true,
        products: json
      };
    },
  });
}
